export const environment = {
  production: true,
  buildId: '3462593415722211',
  configFile: 'config.json',
};
